const subscribers = {};
const EMPTY_LIST = [];
export const getSubscribers = (url) => {
    if (hasSubscribers(url)) {
        return Array.from(subscribers[url]);
    }
    return EMPTY_LIST;
};
export const hasSubscribers = (url) => {
    var _a;
    return ((_a = subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
export const addSubscriber = (url, subscriber) => {
    subscribers[url] = subscribers[url] || new Set();
    subscribers[url].add(subscriber);
};
export const removeSubscriber = (url, subscriber) => {
    subscribers[url].delete(subscriber);
};
export const resetSubscribers = (url) => {
    // eslint-disable-next-line no-prototype-builtins
    if (url && subscribers.hasOwnProperty(url)) {
        delete subscribers[url];
    }
    else {
        for (const url in subscribers) {
            // eslint-disable-next-line no-prototype-builtins
            if (subscribers.hasOwnProperty(url)) {
                delete subscribers[url];
            }
        }
    }
};
